import {
  InputFacebookLoginData,
  InputJoinData,
  InputTwitterLoginData,
} from "@scrile/api-provider/dist/api/LoginProvider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import providers from "@/lib/api";
import { getReferral } from "@/lib/referralHelpers";

const sendReferral = (userId: string) =>
  providers.UserReferringProvider.update({
    data: {
      userId: userId,
      referrerId: getReferral(),
    },
  });

export async function loginFacebook(data: InputFacebookLoginData) {
  const response = await providers.LoginProvider.facebookLogin({ data });
  await sendReferral(response.user.id);
  return response;
}

export async function loginTwitter(data: InputTwitterLoginData) {
  const response = await providers.LoginProvider.twitterLogin({ data });
  await sendReferral(response.user.id);
  return response;
}

export async function loginSignUp(data: InputJoinData) {
  const response = await providers.LoginProvider.join({ data });
  await sendReferral(response.user.id);
  return response;
}
export function loginEmail(email: string, password: string) {
  providers.LoginProvider.setReceiveErrors(false);
  return providers.LoginProvider.login({ email, password });
}

export function loginToken(token: string) {
  return providers.LoginProvider.refreshTokenV2({ token, createNewLongLiveToken: true });
}

export const allowAccess = (user: User | null) =>
  (user && (!!(user as any).phone || (user.emailVerified && !!user.email))) || false;
